
import { defineComponent } from "@vue/composition-api";
import { AuthService } from "@/services/auth.service";
import { container } from "@/services/container";
import { useAuth } from "@/store/auth";
import { mapState } from "pinia";
const authService: AuthService = container.get("authService");

export default defineComponent({
  name: "TopBar",
  computed: {
    ...mapState(useAuth, ["isLoggedIn", "userGroup"]),
  },
  methods: {
    logOut() {
      useAuth().userInfo = null;
      useAuth().userGroup = "";
      authService.logoutAsync().then(() => this.$router.push({ name: "auth" }));
    },
  },
});
